export default __webpack_public_path__ + "static/media/r_wdt_c_0.08a2b773.mp3";